import { Box, Container, Typography, Card, CardContent, CardActionArea } from "@mui/material";
import { Link } from "react-router-dom";
import { Calculator, FileText, LucideIcon } from "lucide-react";

type ToolItem = {
  icon: LucideIcon;
  title: string;
  description: string;
  path: string;
};

const TOOLS: ToolItem[] = [
  {
    icon: FileText,
    title: "管理規約データ抽出ツール",
    description: "管理規約PDFから重説に必要なデータを抽出します",
    path: "/zyusetu/tools/bylaw-extractor",
  },
  {
    icon: Calculator,
    title: "延床面積計算ツール",
    description: "登記簿PDFから延床面積を計算します",
    path: "/zyusetu/tools/area-calculator",
  },
];

export function ToolsPage() {
  return (
    <Container maxWidth="lg">
      <Box sx={{ my: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          ツール
        </Typography>
        <Typography variant="body1" sx={{ mb: 4 }}>
          各種ツールはこちらから利用できます。
        </Typography>

        <Box sx={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))", gap: 3 }}>
          {TOOLS.map((tool) => (
            <Card key={tool.path}>
              <CardActionArea component={Link} to={tool.path} sx={{height: "100%"}}>
                <CardContent sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <tool.icon size={32} />
                  <Box>
                    <Typography variant="h6" component="div">
                      {tool.title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {tool.description}
                    </Typography>
                  </Box>
                </CardContent>
              </CardActionArea>
            </Card>
          ))}
        </Box>
      </Box>
    </Container>
  );
}
